import firebase from 'firebase';

var config = {
  apiKey: "AIzaSyBLqH1-0jlWdoARuOaYPsh_3ByBPgaeoJY",
  authDomain: "world-parts-online.firebaseapp.com",
  databaseURL: "https://world-parts-online.firebaseio.com",
  storageBucket: "world-parts-online.appspot.com",
  messagingSenderId: "576071050628"
};

var fireApp = firebase.initializeApp(config);

export default fireApp;


// WEBPACK FOOTER //
// ./E:/dev/repos/wpo_sitecontrol/src/services/fireConfig.js